// --- src/components/Toolbar.js ---
import React from 'react';
// UPDATED: Removed Plus, X, PencilLine
import { ArrowUp, ArrowDown, Copy, CopyPlus, Share, Eye, Clipboard, GripHorizontal } from 'lucide-react';

/**
 * Toolbar component for block actions (static for the demo).
 * Now accepts blockGuid prop for Copy GUID action.
 */
const Toolbar = ({ blockGuid, classes }) => {

  const handleCopyGuid = (guid) => {
      if (!guid) return;
      navigator.clipboard.writeText(guid).then(() => {
          // Optional: Add feedback (e.g., temporary message)
          console.log("GUID copied:", guid);
      }).catch(err => {
          console.error('Failed to copy GUID:', err);
      });
  };

  return (
    <div className={`${classes}  md:-ml-[3px] block-toolbar flex items-center space-x-1 text-gray-500`}> {/* Reduced spacing with space-x-1 */}
      {/* Drag Handle */}
      <span className="toolbar-drag-handle cursor-grab p-0.5 rounded hover:bg-gray-200" title="Drag handle (inactive)">
        <GripHorizontal size={16} />
      </span>
      {/* Movement Buttons */}
      <button className="toolbar-up p-0.5 rounded hover:bg-gray-200 hover:text-blue-700" disabled title="Move up (inactive)">
        <ArrowUp size={14} /> {/* Slightly smaller icons */}
      </button>
      <button className="toolbar-down p-0.5 rounded hover:bg-gray-200 hover:text-blue-700" disabled title="Move down (inactive)">
        <ArrowDown size={14} />
      </button>
      {/* Copy Buttons */}
      <button className="toolbar-duplicate p-0.5 rounded hover:bg-gray-200 hover:text-blue-700" disabled title="Duplicate (inactive)">
        <Copy size={14} />
      </button>
      <button className="toolbar-duplicate-to p-0.5 rounded hover:bg-gray-200 hover:text-blue-700" disabled title="Duplicate to... (inactive)">
        <CopyPlus size={14} />
      </button>
       {/* Copy GUID Button (Optional) - Added placeholder */}
       {blockGuid && (
            <button
               className="toolbar-copy-guid p-0.5 rounded hover:bg-gray-200 hover:text-blue-700"
               onClick={(e) => { e.stopPropagation(); handleCopyGuid(blockGuid); }} // Prevent click propagation if needed
               title={`Copy GUID: ${blockGuid} (inactive)`}
               disabled // Still disabled for static demo
            >
               <Clipboard size={14} />
            </button>
       )}
      {/* Action Buttons */}
      <button className="toolbar-share p-0.5 rounded hover:bg-gray-200 hover:text-blue-700" disabled title="Share (inactive)">
        <Share size={14} />
      </button>
      <button className="toolbar-lens p-0.5 rounded hover:bg-gray-200 hover:text-blue-700" disabled title="Create Lens (inactive)">
        <Eye size={14} />
      </button>
    </div>
  );
};

export { Toolbar };